import { useTranslation } from 'react-i18next';

import { Form, FormGenerator } from '@/shared/ui';
import { FormFieldValues } from '@/shared/ui/FormGenerator';
import { SvgIcon } from '@/shared/ui/SvgIcon';

import { companyNameSchema } from '../model/schemas';
import { UpdateCompanyFormValues } from '../model/types';
import { useCompanyName } from '../model/useCompanyName';

import {
  StyledButton,
  StyledContainer,
  StyledFormContainer,
} from './styles/changeCompanyNameFormStyles';

type ChangeCompanyNameFormProps = {
  companyId: string;
  defaultName?: string;
};

const CHANGE_COMPANY_NAME_FORM_ID = 'change-company-name-form';

export const ChangeCompanyName = ({
  companyId,
  defaultName = '',
}: ChangeCompanyNameFormProps) => {
  const { t } = useTranslation();
  const { setCompanyNameMutation } = useCompanyName();

  const { updateCompanyName, isPending } = setCompanyNameMutation;

  const handleSubmit = async (data: UpdateCompanyFormValues) => {
    await updateCompanyName({
      companyId,
      name: data.name.trim(),
    });
  };

  const formScheme = [
    {
      name: 'name',
      label: t('company:settingsPage.inputs.companyName.label'),
      type: FormFieldValues.Default,
      inputProps: {
        endAdornment: <SvgIcon name="edit-2" color="primary" />,
      },
    },
  ];

  return (
    <StyledContainer>
      <StyledFormContainer
        direction={{ xs: 'column', sm: 'row' }}
        gap={2}
        alignItems={{ xs: 'stretch', sm: 'end' }}
      >
        <Form
          id={CHANGE_COMPANY_NAME_FORM_ID}
          schema={companyNameSchema(t)}
          onSubmit={handleSubmit}
          defaultValues={{ name: defaultName }}
          mode="onChange"
          sx={{ width: '100%' }}
        >
          <FormGenerator formScheme={formScheme} />
        </Form>
        <StyledButton
          variant="contained"
          type="submit"
          form={CHANGE_COMPANY_NAME_FORM_ID}
          size="medium"
          loading={isPending}
        >
          {t('common:buttons.save')}
        </StyledButton>
      </StyledFormContainer>
    </StyledContainer>
  );
};
